import { resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, withCtx as _withCtx } from "vue"

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_radio_group = _resolveComponent("radio-group")!
  const _component_search_input_form = _resolveComponent("search-input-form")!

  return (_openBlock(), _createBlock(_component_search_input_form, {
    ref: "formRef",
    "info-label": _ctx.localize('EnterPartNoInfo'),
    placeholder: _ctx.localize('EnterPartNo'),
    onSearch: _ctx.findSparePart
  }, {
    options: _withCtx(() => [
      (_ctx.hasPartnerMaterials)
        ? (_openBlock(), _createBlock(_component_radio_group, {
            key: 0,
            "data-items": _ctx.searchModeChoices,
            modelValue: _ctx.searchMode,
            "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.searchMode) = $event)),
            class: "search-mode-selector"
          }, null, 8, ["data-items", "modelValue"]))
        : _createCommentVNode("", true)
    ]),
    _: 1
  }, 8, ["info-label", "placeholder", "onSearch"]))
}